export const shouldQueryNextPath = (pathIndex, portfolio, portfoliosByPath) => {
  const previousPortfolio = portfoliosByPath[pathIndex - 1] || 0;
  return pathIndex === 0 || portfolio > 0 || previousPortfolio > 0;
};
